module.exports = __webpack_public_path__ + "media/images/dashboards/usage-a0cbec8afe1c4532624919e453c094b5.png";